export const AI_EVALUATION_PARAMS = {
  collapse: 'collapse',
  bookId: 'bookId',
  sectionId: 'sectionId',
  chapterId: 'chapterId'
}
